import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "ekeland_token";

export const api = axios.create({ baseURL: API, timeout: 30000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("ekeland:unauthorized"));
    }
    return Promise.reject(error);
  },
);

export function errorMessage(error, fallback = "Noko gjekk gale. Prøv igjen.") {
  if (!error) return fallback;
  if (!error.response) {
    return "Fekk ikkje kontakt med tenaren. Ingenting er lagra – kontroller nettet og prøv igjen.";
  }
  const detail = error.response.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) return detail.message;
  if (Array.isArray(detail)) {
    return detail.map((d) => d.msg || JSON.stringify(d)).join(", ");
  }
  if (error.response.status === 403) return "Du har ikkje tilgang til denne handlinga.";
  if (error.response.status === 404) return "Fann ikkje det du leita etter.";
  return fallback;
}

export function isConflict(error) {
  return error?.response?.status === 409;
}

export function conflictCurrent(error) {
  return error?.response?.data?.detail?.current ?? null;
}

export function blockingIssues(error) {
  return error?.response?.data?.detail?.blocking_issues ?? null;
}

export async function fetchBlobUrl(url) {
  const res = await api.get(url, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

export async function downloadFile(url, filename) {
  const blobUrl = await fetchBlobUrl(url);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename || "fil";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
}

export async function openFile(url) {
  const blobUrl = await fetchBlobUrl(url);
  window.open(blobUrl, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
}

export function newIdempotencyKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
